import React, {useState} from 'react';
import {Button} from '@mui/material';
import useScreenWidth from '../../hooks/useScreenWidth';
import SupportOptions from './SupportOptions';
import {theme} from '../../Theme';
import StandardDialog from '../../common/StyledComponents/StandardDialog';

export const SupportPopup = (props: $TSFixMe) => {
  const width = useScreenWidth();
  const [supportOpen, setSupportOpen] = useState(props.open || false);

  const toggleSupport = () => {
    setSupportOpen(!supportOpen);
    props.handleClose && props.handleClose();
  };

  const onClick = () => {
    toggleSupport();
    (window as $TSFixMe)._chatlio.hide();
  };

  return (
    <>
      {width > 600 && !window.location.pathname.includes('messages') && (
        <Button
          id="chatlio-custom-button"
          onClick={onClick}
          style={{
            position: 'absolute',
            right: 0,
            bottom: 0,
            padding: '16px 24px',
            backgroundColor: theme.palette.blue.main,
            color: theme.palette.secondary.main,
            borderRadius: 50,
            borderBottomRightRadius: 0,
            zIndex: 50000000,
            fontSize: 16,
          }}>
          {/* ONLINE INDICATOR FOR DIRECT SUPPORT */}
          <div
            style={{
              backgroundColor: theme.palette.secondary.main,
              height: 18,
              width: 18,
              borderRadius: '50%',
              position: 'absolute',
              left: -8,
            }}
          />
          <div
            style={{
              backgroundColor: (window as $TSFixMe)._chatlio.isOnline()
                ? '#44b700'
                : theme.palette.gray.medium,
              height: 10,
              width: 10,
              borderRadius: '50%',
              position: 'absolute',
              left: -4,
            }}
          />
          {/* END ONLINE INDICATOR */}
          Support
        </Button>
      )}
      <StandardDialog open={supportOpen} onClose={toggleSupport}>
        <SupportOptions toggleSupport={toggleSupport} />
      </StandardDialog>
    </>
  );
};
